import { PACKS } from "@/lib/content";
import { formatINR } from "@/lib/useReveal";
import { useCart } from "@/context/CartContext";

export const StickyBuyBar = () => {
  const { addPack, setCheckoutOpen, setDrawerOpen } = useCart();
  const pack = PACKS[1]; // most popular default

  const orderNow = () => {
    addPack(pack, { openDrawer: false });
    setDrawerOpen(false);
    setCheckoutOpen(true);
  };

  return (
    <div
      data-testid="sticky-buy-bar"
      className="fixed bottom-0 left-0 right-0 z-[80] flex items-center justify-between gap-3 border-t border-neutral-200 bg-white px-4 py-3 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] lg:hidden"
    >
      <div>
        <div className="flex items-center gap-2">
          <span className="font-num text-2xl font-bold text-[var(--hp-crimson)]">
            {formatINR(pack.price)}
          </span>
          <span className="font-num text-sm text-neutral-400 line-through">
            {formatINR(pack.mrp)}
          </span>
        </div>
        <div className="text-xs font-semibold text-emerald-600">Free Delivery · COD Available</div>
      </div>
      <button
        data-testid="sticky-order-now-button"
        onClick={orderNow}
        className="hp-pulse flex-1 rounded-xl bg-gradient-to-r from-red-600 to-rose-700 py-3 text-base font-bold text-white"
      >
        Order Now
      </button>
    </div>
  );
};
